let list = [
    {
        img: require('@/assets/hezuo/moren.png'),
        name: '跃点教育科技有限公司'
    },
    {
        img: require('@/assets/hezuo/moren.png'),
        name: '攀枝花市钛达科技有限公司'
    },
    {
        img: require('@/assets/hezuo/shucheng.jpg'),
        name: '安徽省舒城中学'
    },
    {
        img: require('@/assets/hezuo/moren.png'),
        name: '四川省遂宁市遂宁中学'
    },
    {
        img: require('@/assets/hezuo/moren.png'),
        name: '瑞安市尚格教育培训有限公司'
    },
    {
        img: require('@/assets/hezuo/hebei.jpeg'),
        name: '河北师范大学'
    },
    {
        img: require('@/assets/hezuo/moren.png'),
        name: '遂昌县恒大办公设备有限公司'
    },
    {
        img: require('@/assets/hezuo/moren.png'),
        name: '南京理工大学'
    },
    {
        img: require('@/assets/hezuo/ntsf.jpeg'),
        name: '江苏省南通师范高等专科学校'
    },
    {
        img: require('@/assets/hezuo/ht.jpeg'),
        name: '新疆和田师范专科学校'
    },
    {
        img: 'https://img.11467.com/cologo/14/45/14452185748708.jpg',
        name: '陕西省西安普菲克培训学校'
    },
    {
        img: require('@/assets/hezuo/moren.png'),
        name: '黑龙江省牡丹江市职教中心'
    },
    {
        img: require('@/assets/hezuo/wj.jpeg'),
        name: '江苏省常州市武进职业教育中心校'
    },
    {
        img: 'https://ss2.meipian.me/users/60449341/49ebc884c2856c4a09d1b0e5e7ea91a2.jpg-mobile',
        name: '江苏省徐州市启点教育培训中心'
    },
    {
        img: require('@/assets/hezuo/zg.png'),
        name: '中国教育出版网'
    },
    {
        img: 'http://img_al.qianlima.com/newDefault/images/logo.gif',
        name: '湖北塞沃斯科技有限公司'
    },
    {
        img: require('@/assets/hezuo/moren.png'),
        name: '江西省南昌创新培训中心'
    },
    {
        img: require('@/assets/hezuo/dh.jpeg'),
        name: '深圳市东湖中学'
    },
];
let list2 = [
    {
        img: require('@/assets/hezuo/moren.png'),
        name: '郎顺教育'
    },
    {
        img: require('@/assets/hezuo/moren.png'),
        name: '紫楠优胜'
    },
    {
        img: require('@/assets/hezuo/moren.png'),
        name: '大华培优'
    },
    {
        img: require('@/assets/hezuo/moren.png'),
        name: '魔都鹿曲星教育'
    },
    {
        img: require('@/assets/hezuo/moren.png'),
        name: '西安森飞电子科技有限公司'
    },
    {
        img: require('@/assets/hezuo/moren.png'),
        name: '新府学外国语学校'
    },
    {
        img: require('@/assets/hezuo/moren.png'),
        name: '动点教育'
    },
    {
        img: require('@/assets/hezuo/moren.png'),
        name: '高殇教育'
    },
    {
        img: require('@/assets/hezuo/moren.png'),
        name: '长沙学有成教育科技有限公司'
    },
]
export default {
    list,
    list2
}